import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    'upload-button': async () => import('../ticket-modal-upload-buttons/TicketUploadButtons.vue')
  }
})
class TicketChatModalAttachDocument extends Vue {
  dtDocumentButtons: {
    index: number, type: string, icon: string, translationKey?: string
  }[]

  @Prop({ default: () => [], type: [Array] })
  value: any[];

  get vModel(): any[] {
    return this.value;
  }
  set vModel(val: any[]) {
    this.$emit('input', val);
  }

  get lblSetting() {
    return require('../../../../locales/generic-labels').default
  }
  /**
   *
   */
  constructor() {
    super();
  }

  get coDocumentButtons() {
    return [
      {
        type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblcondominiumRegulations,
        acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf'
      },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblorderOfAccount, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblreportOfInterventions, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblpvGeneralAssembly, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblQuotation, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblBill, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblManagementReport, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblcall_ForFunds, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblstatementOfExpenditure, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' },
    ]
  }
}

export default TicketChatModalAttachDocument;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-modal-attach-documents/index.ts